import React , { useState, useEffect, useContext, lazy, Suspense } from 'react';
import { Route, Switch, NavLink,  useHistory, useRouteMatch } from 'react-router-dom'
import axios from "axios"; 
import {UserContext} from "../Shared/UserContext.js";
import { Modal } from 'react-responsive-modal';
import ChatroomSkeleton from './ChatroomSkeleton.js';
import NewProject from "./New.js";
import {OrganizationContext} from "../Shared/OrganizationContext.js";
import Premium from "../Subscriptions/Premium.js";
import Project from "./Project.js";
import Archives from "./ArchivedProjects/ArchivedProjects.js";
import ReactTooltip from 'react-tooltip';
import Organizations from "../Navigation/Organizations.js";
import Notifications from "../Notifications/Index.js";
import { isMobile } from "react-device-detect";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TrialEnding from "../Organizations/TrialEnding.js";
import PluginsIndex from "../Plugins/Index.js";
import Checklist from "../Organizations/Checklist.js";
import lottieConfetti from "../Shared/Lotties/lottie-confetti.json";
import { Player } from "@lottiefiles/react-lottie-player";
// ES6 module syntax
import LocalizedStrings from 'react-localization';
import ActiveTimer from "../TimeTracker/ActiveTimer.js";
import {ProjectContext} from "./ProjectContext.js";
import localForage from "localforage";
import { useTranslation } from 'react-i18next';
import KanbanBoardIcon from "../Shared/svg/KanbanBoardIcon.js";
import { useHotkeys } from 'react-hotkeys-hook'
import NewGroup from "../Groups/NewGroup.js";
import Group from "../Groups/Group.js";
import Pusher from 'pusher-js';
import ManyRequests from "../Importers/ManyRequests.js";
import SearchOrNew from "../Navigation/SearchOrNew.js";
import Dashboard from "../Daas/Seller/Dashboard.js";
const LazyProjectWrapper = lazy(() => import("./ProjectWrapper.js"));
const LazyHome = lazy(() => import("./Home.js"));
const LazyServicesWrapper = lazy(() => import("../Daas/Services/ServicesWrapper.js"));
const LazyTaskFormsIndex = lazy(() => import("../Daas/TaskForms/Index.js"));
const LazyTaskBoards = lazy(() => import("../Daas/TaskBoards/TaskBoards.js"));
const LazyClientOnboardingsNew = lazy(() => import("../ClientOnboarding/New.js"));
const LazySettings = lazy(() => import("../Daas/Stripe/Settings.js"));
const LazyChatroomsWrapper = lazy(() => import("../Chatrooms/ChatroomsWrapper.js"));
const LazyReviews = lazy(() => import("../Reviews/Reviews.js"));
const LazyThemes = lazy(() => import("../Themes/Themes.js"));
const LazyTaskTemplates = lazy(() => import("../TaskTemplates/Index.js"));
const LazyPeople = lazy(() => import("../Users/People.js"));
const LazyTimesheetsDashboard = lazy(() => import("../TimeTracker/TimesheetsDashboard.js"));
const LazyReportsWrapper = lazy(() => import("../Reports/ReportsWrapper.js"));
import TaskNotifications from "../Notifications/TaskNotifications.js";
import MobileNavbar from "../Navigation/MobileNavbar.js";
import ImportSubscriptions from "../Onboardings/Sellers/ImportSubscriptions.js";
import cable from "../Shared/actionCable";
import "./Style.css";
import Edit from "../Users/Edit.js";
import EditTheme from "../Organizations/EditTheme.js";
import { isMacOs } from "react-device-detect";
import { HiChevronUpDown } from "react-icons/hi2";
import SupportDropdown from "../Shared/SupportDropdown.js";
import Breadcrumbs from "./Breadcrumbs.js";

let strings = new LocalizedStrings({
 en:{
   dashboard:"Dashboard",
   boiledEgg:"Boiled egg",
   softBoiledEgg:"Soft-boiled egg",
   choice:"How to choose the egg",
   greeting: "Hello"
 },
 it: {
   dashboard:"salpicadero",
   boiledEgg:"Uovo sodo",
   softBoiledEgg:"Uovo alla coque",
   choice:"Come scegliere l'uovo",
   greeting: "hola"
 }
});

const Projects = ({refetchSubscriptions}) => {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const history = useHistory();
  useHotkeys(`shift+r`, () => history.push(`/o/${match.params.organization_id}/dashboard`), [])
  useHotkeys(`shift+m`, () => history.push(`/o/${match.params.organization_id}/dashboard/my-tasks`), [])
  useHotkeys(`shift+a`, () => history.push(`/o/${match.params.organization_id}/dashboard/analytics`), [])
  useHotkeys(`shift+i`, () => history.push(`/o/${match.params.organization_id}/chatrooms`), [])
  useHotkeys(`shift+p`, () => history.push(`/o/${match.params.organization_id}/people`), [])
  const currentUser = useContext(UserContext);
  const {organizationAuthorizations, hasPermission} = useContext(OrganizationContext)
  const [loaded, setLoaded] = useState(false)
  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState(false);
  const onOpenModal = () => { setOpen(true); };
  const [openArchived, setOpenArchived] = useState(false)
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false); 
  const [showSidenav, setShowSidenav] = useState(!isMobile)
  const [projects, setProjects] = useState([]);
  const [privateProjects, setPrivateProjects] = useState([]);
  const [screenshotProject, setScreenshotProject] = useState();
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [testers, setTesters] = useState([]);
  const [openPlugins, setOpenPlugins] = useState(false);
  const [timesheets, setTimesheets] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [step, setStep] = useState(1);
  const [electron, setElectron] = useState(window && window.process && window.process.type === 'renderer');
  const [hideProjectMenu, setHideProjectMenu] = useState(JSON.parse(localStorage.getItem("hideProjectMenu") || true))
  const [hideProjects, setHideProjects] = useState(JSON.parse(localStorage.getItem("hideProjects")));
  const [hideSetupMenu, setHideSetupMenu] = useState(JSON.parse(localStorage.getItem("hideSetupMenu")));
  const [hideWorkspaceMenu, setHideWorkspaceMenu] = useState(JSON.parse(localStorage.getItem("hideWorkspaceMenu")))
  const [requestsMenu, setRequestsMenu] = useState(location.pathname.includes("dashboard") || false);
  const [groups, setGroups] = useState([]);
  const [openManyRequests, setOpenManyRequests] = useState(false);
  const [openCmdk, setOpenCmdk] = useState(false);
  const [refreshData, setRefreshData] = useState(0);
  const [newTasks, setNewTasks] = useState([]);
  const [taskboardTemplates, setTaskboardTemplates] = useState([]);
  const [openImportSubscriptions, setOpenImportSubscriptions] = useState(false);
  const [openTheme, setOpenTheme] = useState(false);
  const [openMobilePopup, setOpenMobilePopup] = useState(false);
  const [openEditAccount, setOpenEditAccount] = useState(false);
  const [totalProjectUnreadMessages, setTotalProjectUnreadMessages] = useState(0);

  useEffect(() => {
    // Create a Pusher client
    const pusherAccount = new Pusher('683f89863cff332fae20', {
      cluster: 'us2',
      encrypted: true
    });

    // Subscribe to a channel
    const channel = pusherAccount.subscribe(`${match.params.organization_id}-projects`);


    // Actioncable
    const actioncableChannel = cable.subscriptions.create(
      { 
        channel: "OrganizationsChannel", 
        organization_id: match.params.organization_id
      }, 
      {
        received(data) {
          // console.log(data);
          if(data.function === "fetchProjects"){
            fetchProjects();
          }
        },
      }
    );

    // Bind to an event on the channel
    channel.bind('channel', data => {
      console.log(data);
      fetchProjects();
      fetchChatroomsUnread();
      fetchTimesheets();
    });

    // Unsubscribe from the channel when the component unmounts
    return () => {
      channel.unsubscribe();
      actioncableChannel.unsubscribe();
    };
  },[])

  useEffect(() => {
    localStorage.setItem("hideProjects", hideProjects);
    localStorage.setItem("hideProjectMenu", hideProjectMenu);
    localStorage.setItem("hideSetupMenu", hideSetupMenu);
    localStorage.setItem("hideWorkspaceMenu", hideWorkspaceMenu);
  }, [hideProjects, hideProjectMenu, hideSetupMenu, hideWorkspaceMenu])

  useEffect(() => {
    const interval = setInterval(() => {
      setStep(2)
    }, 4000);
  
    // Cleanup function to clear the interval when component unmounts
    return () => clearInterval(interval);
  }, []); // Empty dependency array to run the effect only once on mount

  useEffect(() => {
    fetchProjects();
    fetchChatroomsUnread();
    fetchTimesheets();
    fetchTaskboardTemplates();
  }, [match.params.organization_id]);

  // Update LocalForage when projects state changes
  useEffect(() => {
    localForage.getItem(`${match.params.organization_id}-projects`)
      .then(function (value) {
        if (value) {
          value.projects = projects;
          value.groups = groups;
          localForage.setItem(`${match.params.organization_id}-projects`, value)
        }
      })
  }, [projects, groups]);

  useEffect(() => {
    // Load data from LocalForage when the component mounts
    localForage.getItem(`${match.params.organization_id}-projects`).then(function (value) {
      if (value) {
        setProjects(value.projects);
        setPrivateProjects(value.private_projects);
        setScreenshotProject(value.screenshot_project);
        setTesters(value.testers);
        setGroups(value.groups);
        setLoaded(true);
      }
    }).catch(function(err) {
      console.error('Error loading data from LocalForage:', err);
      // Fetch projects from the server in case of an error
      fetchProjects();
    });
  }, []); 

  useEffect(() => {
    const total = [...projects].reduce((sum, project) => {
      return sum + (project.unread_messages?.length || 0);
    }, 0);
    setTotalProjectUnreadMessages(total);
  }, [projects]);

  const fetchChatroomsUnread = () => {
    axios.get(`/api/o/${match.params.organization_id}/all_unread_messages.json`)
    .then(function(response){
      // console.log(response);
      if(response.data.success){
        setUnreadMessages(response.data.unread_messages)
      } else {
        notice(response.data.error)
      }
    })
    .catch(function(error){
      console.log(error)
      notice(error)
    })
    .then(function () {
      // always executed
    });
  }

  const fetchProjects = () => {
    axios.get(`/api/o/${match.params.organization_id}/projects.json`)
    .then(function(response){
      // console.log(response);
      if(response.data.success){
        setProjects(response.data.projects);
        setPrivateProjects(response.data.private_projects);
        setScreenshotProject(response.data.screenshot_project);
        setTesters(response.data.testers);
        setGroups(response.data.groups);
        if(response.data.projects.length == 0){
          // notice("You don't have access to this workspace"); 
          // window.location = "/"
        }
        setLoaded(true);

        localForage.setItem(`${match.params.organization_id}-projects`, response.data).then(function (value) {
          console.log(value);
        }).catch(function(err) {
          // This code runs if there were any errors
          console.log(err);
        });
      } else {
        notice(response.data.error)
      }
    })
    .catch(function(error){
      console.log(error)
      notice(error)
    })
    .then(function () {
      // always executed
    });
  }
  window.fetchProjects = fetchProjects;

  const fetchProjectsAsync = async () => {
    await axios.get(`/api/o/${organizationAuthorizations.organization.token}/projects.json`)
    .then(function(response){
      // console.log(response);
      if(response.data.success){
        setProjects(response.data.projects);
        setPrivateProjects(response.data.private_projects);
        setScreenshotProject(response.data.screenshot_project);
        setGroups(response.data.groups);
        refetchSubscriptions();
        setLoaded(true);
      } else {
        notice(response.data.error)
      }
    })
    .catch(function(error){
      console.log(error)
      notice(error)
    })
    .then(function () {
      // always executed
    });
  }
  window.fetchProjectsAsync = fetchProjectsAsync;

  const fetchTimesheets = () => {
    axios.get(`/api/o/${match.params.organization_id}/active_timesheets.json`)
    .then(function(response){
      // console.log(response);
      if(response.data.success){
        setTimesheets(response.data.timesheets);
        // notice("Successfully fetched timesheets")
      } else {

      }
    })
    .catch(function(error){
      console.log(error)
      notice("An error occured")
    })
    .then(function () {
      // always executed
    });
  };

  const fetchCheckoutUrl = () => {
    setDisabled(true)
    axios.post(`/api/o/${match.params.organization_id}/stripe_checkout?redirect_path=${window.location.href}&tolt_referral=${window.tolt_referral}`)
    .then(function(response){
      console.log(response);
      window.location.replace(response.data.payment_url);
      refetchData();
    })
    .catch(function(error){
      console.log(error)
      // notice("An error occured")
    })
    .then(function () {
      // setDisabled(false)
    });
  };

  const fetchTaskboardTemplates = () => {
    axios.get(`/api/o/${match.params.organization_id}/taskboards.json`)
    .then(function(response){
      setTaskboardTemplates(response.data.taskboards)
    })
    .catch(function(error){
      console.log(error)
      notice("An error occured")
    })
  }

  const timesheets_list = timesheets.filter(item => !item.finished).map(timesheet => {
    return(
      <ActiveTimer key={timesheet.updated_at} timesheet={timesheet} refetchData={fetchTimesheets}/>
    )
  })

  const private_projects_list = privateProjects.map((project, index) => {
    return (
      <Project key={project.token} fetchProjects={fetchProjects} project={project} privateProject={true} index={index}/>
    )
  })

  const onDragEnd = (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) {
      return;
    }

    // If the project is dropped in the same place, do nothing
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    const projectId = draggableId.split('-')[1];

    // Moving project between groups or from main list to group
    if (source.droppableId !== destination.droppableId) {
      const sourceGroupToken = source.droppableId === 'projectList' ? null : source.droppableId;
      const destinationGroupToken = destination.droppableId === 'projectList' ? null : destination.droppableId;

      let updatedProjects = [...projects];
      let updatedGroups = [...groups];
      let movedProject;

      // Remove project from source
      if (sourceGroupToken) {
        updatedGroups = updatedGroups.map(group => {
          if (group.token === sourceGroupToken) {
            movedProject = group.projects.find(p => p.token === projectId);
            return {
              ...group,
              projects: group.projects.filter(p => p.token !== projectId)
            };
          }
          return group;
        });
      } else {
        movedProject = updatedProjects.find(p => p.token === projectId);
        updatedProjects = updatedProjects.filter(p => p.token !== projectId);
      }

      // Add project to destination
      if (destinationGroupToken) {
        updatedGroups = updatedGroups.map(group => {
          if (group.token === destinationGroupToken) {
            return {
              ...group,
              projects: [...group.projects.slice(0, destination.index), movedProject, ...group.projects.slice(destination.index)]
            };
          }
          return group;
        });
      } else {
        updatedProjects.splice(destination.index, 0, movedProject);
      }

      setProjects(updatedProjects);
      setGroups(updatedGroups);
      updateProjectGroup(projectId, destinationGroupToken);
    } else {
      // Reordering within the same list (either main list or within a group)
      if (source.droppableId === 'projectList') {
        // Reorder within main project list
        const newProjects = Array.from(projects);
        const [reorderedProject] = newProjects.splice(source.index, 1);
        newProjects.splice(destination.index, 0, reorderedProject);
        setProjects(newProjects);
        updateProjectOrder(newProjects);
      } else {
        // Reorder within a group
        const groupToken = source.droppableId;
        const updatedGroups = groups.map(group => {
          if (group.token === groupToken) {
            const newGroupProjects = Array.from(group.projects);
            const [reorderedProject] = newGroupProjects.splice(source.index, 1);
            newGroupProjects.splice(destination.index, 0, reorderedProject);
            return { ...group, projects: newGroupProjects };
          }
          return group;
        });
        setGroups(updatedGroups);
        updateProjectOrderInGroup(groupToken, updatedGroups.find(g => g.token === groupToken).projects);
      }
    }
  };

  const updateProjectGroup = (projectId, groupToken) => {
    const apiUrl = `/api/o/${match.params.organization_id}/projects/${projectId}/update_group`;
    axios.post(apiUrl, { group_id: groupToken })
      .then(response => {
        console.log('Project group updated successfully', response.data);
      })
      .catch(error => {
        console.error('Error updating project group', error);
      });
  };

  const updateProjectOrder = (newProjects) => {
    const apiUrl = `/api/o/${match.params.organization_id}/projects/reorder`;
    axios.post(apiUrl, newProjects)
      .then(response => {
        console.log('Project positions updated successfully', response.data);
      })
      .catch(error => {
        console.error('Error updating project positions', error);
      });
  };

  const updateProjectOrderInGroup = (groupToken, projects) => {
    const apiUrl = `/api/o/${match.params.organization_id}/groups/${groupToken}/reorder_projects`;
    axios.post(apiUrl, { projects: projects.map(p => p.token) })
      .then(response => {
        console.log('Project positions in group updated successfully', response.data);
      })
      .catch(error => {
        console.error('Error updating project positions in group', error);
      });
  };

  

  return(
    organizationAuthorizations != null &&
    <React.Fragment>
      <ProjectContext.Provider value={{fetchTimesheets, timesheets, testers, electron, projects, setProjects, groups, fetchChatroomsUnread, fetchProjects, setGroups, openCmdk, setOpenCmdk, setRefreshData, refreshData, setNewTasks, setShowSidenav, showSidenav, taskboardTemplates, fetchTaskboardTemplates}}>
        <Modal open={openSubscriptionModal} onClose={() => setOpenSubscriptionModal(false)} className="modal-body-white" classNames={{modal: 'width-1000-modal'}} center>
          <Premium organization_id={organizationAuthorizations.organization.token}/>
        </Modal>

        <div className="platform-wrapper">
          { showSidenav && 
            <>
              {/* <SideNavigationOrganizations /> */}
              <div className={`display-column sidebar-background-color workspace-sidenav ${isMobile ? "animated fadeInLeft" : "animated"}`} style={{minWidth: `260px`, width: "260px", transition: "width 200ms", paddingTop: "15px"}}>
                {loaded &&
                  <div id="filterChatrooms">
                    <Organizations currentUser={currentUser} organizationAuthorizations={organizationAuthorizations}/>
                    {organizationAuthorizations.organization.organization_user && !window.location.pathname.includes('/portal/') && <SearchOrNew />}
                    {timesheets_list}
                  </div>
                }
                
                <div style={{overflow: "auto"}}>
                  { loaded ? (
                    <div id="filterChatrooms" style={{overflow: "auto", height: "100%", paddingBottom: "150px"}}>
                      <ReactTooltip effect="solid" backgroundColor="black" textColor="white" delayShow={200}/>
                      <React.Fragment>
                        <div className="mt-5 animate fadeIn">
                          {(organizationAuthorizations.organization.organization_user || organizationAuthorizations.project_user) && 
                            <React.Fragment>
                              <label onClick={() => setHideWorkspaceMenu(!hideWorkspaceMenu)} className="sidebar-text-color sidebar-label">
                                {t("Workspace")}
                                <i class={`sidebar-text-color fas ml-5 ${hideWorkspaceMenu ? "fa-caret-right" : "fa-caret-down"}`}></i>
                              </label>
                              
                              {!hideWorkspaceMenu && 
                                <div className="animated fadeIn">
                                  <li className="daas-platform-links-li animate color-1">
                                    <NavLink to={`/o/${match.params.organization_id}/dashboard`} className="daas-platform-links-a sidebar-text-color display-flex space-between align-content-center" activeClassName="sidebar-background-color">
                                      <div className="display-flex align-content-center" style={{marginLeft: -2}}>
                                        {/* <i class="fal fa-layer-group mr-10"></i> */}
                                        <i className="mr-10 opacity-6">
                                          <KanbanBoardIcon size={16} color="var(--text-color)" />
                                        </i>
                                        {t("Requests")}
                                      </div>
                                    </NavLink>
                                    <i className={`fal ${window.location.pathname.includes(`/o/${match.params.organization_id}/dashboard/`) ? "fa-angle-down" : "fa-angle-right"} daas-platform-links-a-angle`}></i>
                                  </li>

                                  {window.location.pathname.includes(`/o/${match.params.organization_id}/dashboard`) && 
                                    <div className="animated fadeIn">
                                      <li className="daas-platform-links-li sidebar-text-color side-nav-submenu-li">
                                        <NavLink activeClassName="background-active" to={`/o/${match.params.organization_id}/dashboard`} exact className="daas-platform-links-a sidebar-text-color side-nav-submenu" data-html={true} data-tip={`<div class="tooltip-keybind-wrapper"><span class="tooltip-keybind">SHIFT</span> + <span class="tooltip-keybind">r</span></div>`}>
                                          {t("All requests")}
                                        </NavLink>
                                      </li>
    
                                      <li className="daas-platform-links-li animate sidebar-text-color side-nav-submenu-li">
                                        <NavLink to={`/o/${match.params.organization_id}/dashboard/my-tasks`} activeClassName="background-active" className="daas-platform-links-a sidebar-text-color side-nav-submenu" data-html={true} data-tip={`<div class="tooltip-keybind-wrapper"><span class="tooltip-keybind">SHIFT</span> + <span class="tooltip-keybind">m</span></div>`}>
                                          {t("Assigned to me")}
                                        </NavLink>
                                      </li>
                                    </div>
                                  }

                                  {organizationAuthorizations.organization.organization_user && 
                                    <>
                                      {hasPermission("inbox") && testers.some(tester => tester.kind === 'chatroom') && 
                                        <li className="daas-platform-links-li animate color-1">
                                          <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/chatrooms`} className="daas-platform-links-a sidebar-text-color" data-html={true} data-tip={`<div class="tooltip-keybind-wrapper"><span class="tooltip-keybind">SHIFT</span> + <span class="tooltip-keybind">i</span></div>`}>
                                          <div>
                                            <i class="fal fa-inbox mr-10"></i> {t("Inbox")}
                                          </div>
                                            {/* {unreadMessages > 0 && 
                                              <span className="notification-dot">{unreadMessages}</span>
                                            } */}
                                            {totalProjectUnreadMessages > 0 && 
                                              <span className="unread-messages-dot ml-5"></span>
                                            }
                                          </NavLink>
                                        </li>
                                      }

                                      {hasPermission("analytics") && 
                                        <li className="daas-platform-links-li animate color-1">
                                            <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/dashboard/analytics`} className="daas-platform-links-a sidebar-text-color"  data-html={true} data-tip={`<div class="tooltip-keybind-wrapper"><span class="tooltip-keybind">SHIFT</span> + <span class="tooltip-keybind">a</span></div>`}>
                                              <i class="fal fa-chart-bar mr-10"></i> {t("Analytics")}
                                          </NavLink>
                                        </li>
                                      }

                                      {/* {hasPermission("website") && testers.some(tester => tester.kind === 'themes') && 
                                        <li className="daas-platform-links-li animate color-1">
                                          <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/themes`} className="daas-platform-links-a sidebar-text-color">
                                            <i class="fal fa-browser mr-10"></i> {t("Website")}
                                          </NavLink>
                                        </li>
                                      } */}
                                    </>
                                  }

                                  {(testers.some(tester => tester.kind === "Timesheets")) && 
                                    <li className="daas-platform-links-li animate color-1">
                                      <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/timesheets`} className="daas-platform-links-a sidebar-text-color">
                                        <i class="fal fa-clock mr-10"></i> {t("Timesheets")}
                                      </NavLink>
                                    </li>
                                  }
                                </div>
                              }

                              {organizationAuthorizations.organization.organization_user &&
                                <>
                                {(hasPermission("my_services") && 
                                  hasPermission("customizations") && 
                                  hasPermission("workflow_setup") && 
                                  hasPermission("people") && 
                                  hasPermission("plugins")) && 
                                  <label onClick={() => setHideSetupMenu(!hideSetupMenu)} className="sidebar-text-color font-12 cursor-pointer opacity-10-hover sidebar-label">
                                    Setup <i class={`sidebar-text-color fas ml-5 ${hideSetupMenu ? "fa-caret-right" : "fa-caret-down"}`}></i>
                                  </label>
                                }
                                  
                                  {!hideSetupMenu && 
                                    <div className="animated fadeIn">
                                      {hasPermission("my_services") && 
                                      <>
                                        <li className="daas-platform-links-li animate color-1">
                                          <NavLink activeClassName="" to={`/o/${match.params.organization_id}/billing/services`} className="daas-platform-links-a sidebar-text-color">
                                            <i class="fal fa-credit-card mr-10"></i> {t("Billing")}
                                          </NavLink>
                                          <i className={`fal ${window.location.pathname.includes(`/o/${match.params.organization_id}/billing/`) ? "fa-angle-down" : "fa-angle-right"} daas-platform-links-a-angle`}></i>
                                        </li>
                                        
                                        {window.location.pathname.includes(`/o/${match.params.organization_id}/billing/`) &&
                                          <>
                                            <li className="daas-platform-links-li sidebar-text-color side-nav-submenu-li">
                                              <NavLink exact activeClassName="background-active" to={`/o/${match.params.organization_id}/billing/services`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                                {t("Services")}
                                              </NavLink>
                                            </li>
                                          
                                            <li className="daas-platform-links-li sidebar-text-color side-nav-submenu-li">
                                              <NavLink activeClassName="background-active" to={`/o/${match.params.organization_id}/billing/discounts`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                                {t("Discounts")}
                                              </NavLink>
                                            </li>

                                            <li className="daas-platform-links-li sidebar-text-color side-nav-submenu-li">
                                              <NavLink activeClassName="background-active" to={`/o/${match.params.organization_id}/billing/invoices`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                                {t("Invoices")}
                                              </NavLink>
                                            </li>

                                            <li className="daas-platform-links-li sidebar-text-color side-nav-submenu-li">
                                              <NavLink activeClassName="background-active" to={`/o/${match.params.organization_id}/billing/settings`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                                {t("Checkout settings")}
                                              </NavLink>
                                            </li>

                                            <li className="daas-platform-links-li animate sidebar-text-color side-nav-submenu-li">
                                              <NavLink to={`/o/${match.params.organization_id}/billing/referrals`} activeClassName="background-active" className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                                {t("Referral Program")}
                                              </NavLink>
                                            </li>
                                          </>
                                        }

                                      </>
                                      }

                                      {hasPermission("workflow_setup") && 
                                        <li className="daas-platform-links-li animate color-1">
                                          <NavLink activeClassName="" to={`/o/${match.params.organization_id}/workflow/forms`} className="daas-platform-links-a sidebar-text-color display-flex space-between align-content-center" onClick={() => setHideProjectMenu(!hideProjectMenu)}>
                                            <div className="display-flex align-content-center">
                                              <i class="fal fa-user-cog opacity-6" style={{marginRight: "8px"}}></i>{t("Workflow")}
                                            </div>
                                          </NavLink>
                                          <i className={`fal ${window.location.pathname.includes(`/o/${match.params.organization_id}/workflow`) ? "fa-angle-down" : "fa-angle-right"} daas-platform-links-a-angle`}></i>
                                        </li>
                                      }
    
                                      {window.location.pathname.includes("/workflow/") && hasPermission("workflow_setup") && 
                                        <div className="animated fadeIn">
                                          <li className="daas-platform-links-li animate sidebar-text-color side-nav-submenu-li">
                                            <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/workflow/forms`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                              {t('Forms')}
                                            </NavLink>
                                          </li>
                                          
                                          <li className="daas-platform-links-li sidebar-text-color side-nav-submenu-li">
                                            <NavLink activeClassName="background-active" to={`/o/${match.params.organization_id}/workflow/client-onboarding`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                              {t("Client onboarding")}
                                            </NavLink>
                                          </li>

                                          {/* <li className="daas-platform-links-li animate sidebar-text-color side-nav-submenu-li">
                                            <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/task_templates`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                              {t('Task templates')}
                                            </NavLink>
                                          </li> */}
          
                                          {testers.some(tester => tester.kind === 'Task reviews') && 
                                            <li className="daas-platform-links-li animate sidebar-text-color side-nav-submenu-li">
                                              <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/workflow/reviews`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                                {t("Task reviews")}
                                              </NavLink>
                                            </li>
                                          }
          
                                          <li className="daas-platform-links-li animate sidebar-text-color side-nav-submenu-li">
                                            <NavLink activeClassName="background-active"  to={`/o/${match.params.organization_id}/workflow/taskboard-templates`} className="daas-platform-links-a sidebar-text-color side-nav-submenu">
                                              {t("Taskboard templates")}
                                            </NavLink>
                                          </li>
                                        </div>
                                      }

                                      {hasPermission("customizations") && 
                                        <li className="daas-platform-links-li animate color-1">
                                          <NavLink to={`/o/${match.params.organization_id}/settings/company`} activeClassName="background-active" className={`daas-platform-links-a sidebar-text-color ${window.location.pathname.includes("/settings/") ? "background-active" : ""}`}>
                                            <i class="fal fa-paint-brush mr-10"></i> {t("Customizations")}
                                          </NavLink>
                                        </li>
                                      }

                                      {hasPermission("people") && 
                                        <li className="daas-platform-links-li animate color-1">
                                          <NavLink to={`/o/${match.params.organization_id}/people/team`} className={`daas-platform-links-a sidebar-text-color ${window.location.pathname.includes("/people/") ? "background-active" : ""}`} data-html={true} data-tip={`<div class="tooltip-keybind-wrapper"><span class="tooltip-keybind">SHIFT</span> + <span class="tooltip-keybind">p</span></div>`}>
                                            <i class="fal fa-users mr-10"></i> {t("People")}
                                          </NavLink>
                                        </li>
                                      }
    
                                      {(organizationAuthorizations.organization.organization_user && hasPermission("plugins")) && 
                                        <li className="daas-platform-links-li animate color-1">
                                          <a onClick={() => setOpenPlugins(true)} activeClassName="background-active" className="daas-platform-links-a sidebar-text-color">
                                            <i class="far fa-shapes mr-10"></i> {t("Plugins")}
                                          </a>
    
                                          <Modal open={openPlugins} onClose={() => setOpenPlugins(false)} className="modal-body-white" classNames={{modal: 'width-1000'}} center>
                                            <PluginsIndex closeModal={() => setOpenPlugins(false)}/>
                                          </Modal>
                                        </li>
                                      }
    
                                    </div>
                                  }
                                </>
                              }
                            </React.Fragment>
                          }
                          
                          <label className="sidebar-text-color project-side-navigation-label hover-parent-opacity sidebar-text-color font-12 mb-8 opacity-1">
                            <div className="display-flex align-items-center cursor-pointer opacity-4 opacity-10-hover" onClick={() => setHideProjects(!hideProjects)}>
                              <div>
                                {t("Client projects")}
                              </div>
                              <i class={`sidebar-text-color fas ml-5 ${hideProjects ? "fa-caret-right" : "fa-caret-down"}`}></i>
                            </div>

                            <div>
                              <div class="btn-group hover-child-opacity">
                                <a class="sidebar-text-color dropdown-toggle btn btn-small background-hover" data-toggle="dropdown">
                                  <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <ul class="dropdown-menu animated fadeInUp pull-right" role="menu" style={{minWidth: "unset"}}>
                                  <li><a onClick={() => setOpenArchived(true)}><i class="fal fa-trash mr-5"></i>{t("Archives")}</a></li>
                                  <Modal open={openArchived} onClose={() => setOpenArchived(false)} className="modal-body-white" classNames={{modal: 'width-800'}} center>
                                    <Archives refetchData={fetchProjects}/>
                                  </Modal>

                                  {testers.some(tester => tester.kind === "manyrequests") && 
                                    <li><a onClick={() => setOpenManyRequests(true)}><i class="fal fa-trash mr-5"></i>{t("Import from Many Requests")}</a></li>
                                  }

                                  <Modal open={openManyRequests} onClose={() => setOpenManyRequests(false)} className="modal-body-white" classNames={{modal: 'width-500'}} center>
                                    <ManyRequests organization_id={match.params.organization_id} refetchData={fetchProjects} closeModal={() => setOpenManyRequests(false)}/>
                                  </Modal>
                                </ul>
                              </div>

                              {organizationAuthorizations.organization.organization_user && 
                                <React.Fragment>
                                  <div class="btn-group">
                                    <a type="button" class="btn btn-small background-hover color-1 dropdown-toggle opacity-10-hover opacity-6" data-toggle="dropdown">
                                      <i class="fas fa-plus-circle"></i>
                                    </a>
                                    <ul class="dropdown-menu pull-right min-width-unset animated fadeInUp" role="menu">
                                      <li>
                                        <a onClick={() => {organizationAuthorizations.allow_upload ? onOpenModal() : setOpenSubscriptionModal(true)}}>
                                          <i className="fal fa-layer-plus"></i>Client
                                        </a>
                                      </li>
                                      <li><a onClick={() => setOpenGroup(true)}><i className="fal fa-object-group"></i>Group</a></li>

                                      {organizationAuthorizations?.organization?.stripe_account && 
                                        <>
                                          <li class="divider"></li>
                                          <li>
                                            <a onClick={() => {setOpenImportSubscriptions(true);} }><i className="fab fa-cc-stripe mr-5"></i>Import subscriptions</a>
                                          </li>

                                          <Modal open={openImportSubscriptions} onClose={() => setOpenImportSubscriptions(false)} className="modal-body-white" classNames={{modal: 'width-800'}} center>
                                            <h4 className="color-black-always modal-title">Import subscriptions</h4>
                                            <p className="modal-description mb-30">We'll import the subscription and send an invite link to your client if you wish.</p>
                                            <ImportSubscriptions setImportFinished={() => {setOpenImportSubscriptions(false)}} refetchData={fetchProjects} project_id={null}/>
                                          </Modal>
                                        </>
                                      }
                                    </ul>
                                  </div>
                                  <Modal open={open} onClose={() => setOpen(false)} className="modal-body-white" classNames={{modal: 'width-500'}} center>
                                    <NewProject organization_id={organizationAuthorizations.organization.token} onCloseModal={() => setOpen(false)} refetchData={fetchProjects} parent_project_id={null}/>
                                  </Modal>

                                  <Modal open={openGroup} onClose={() => setOpenGroup(false)} className="modal-body-white" classNames={{modal: 'width-500'}} center>
                                    <h4 className="color-black-always modal-title">Organize projects better with groups</h4>
                                    <NewGroup organization_id={organizationAuthorizations.organization.token} onCloseModal={() => setOpenGroup(false)} refetchData={fetchProjects}/>
                                  </Modal>
                                </React.Fragment>
                              }
                            </div>
                          </label>

                          {!hideProjects && 
                            <div className="animated fadeIn">
                              <DragDropContext onDragEnd={onDragEnd}>
                                <div className="groups-container">
                                  {groups?.map((group) => (
                                    <Droppable key={group.token} droppableId={group.token}>
                                      {(provided) => (
                                        <li
                                          {...provided.droppableProps}
                                          ref={provided.innerRef}
                                          className="group-container daas-platform-links-li color-1 hover-parent-opacity hover-parent"
                                        >
                                          <Group group={group} refetchData={fetchProjects}/>
                                          {provided.placeholder}
                                        </li>
                                      )}
                                    </Droppable>
                                  ))}
                                </div>
                                
                                <Droppable droppableId="projectList">
                                  {(provided) => (
                                    <ul {...provided.droppableProps} ref={provided.innerRef} style={{paddingLeft: 0, listStyle: "none"}}>
                                      {projects.filter(project => !project.group_id).map((project, index) => (
                                        project && project.token ? (
                                          <Draggable key={project.token} draggableId={`project-${project.token}`} index={index}>
                                            {(provided) => (
                                              <li className="side-navigation-project-item" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                <Project key={project.token} fetchProjects={fetchProjects} project={project} privateProject={false} index={index}/>
                                              </li>
                                            )}
                                          </Draggable>
                                        ) : null
                                      ))}
                                      {provided.placeholder}
                                    </ul>
                                  )}
                                </Droppable>
                              </DragDropContext>

                              {private_projects_list}
                            </div>
                          }  
                          </div>
                        </React.Fragment>
                      </div>
                    ):(
                      <ChatroomSkeleton />
                    )}
                  </div>
                <div>
                  <div className="navigation-user-wrapper">
                    <SupportDropdown />
                    {/* <Checklist /> */}
                    <div class="btn-group dropup" style={{width: "100%"}}>
                      <div type="button" class="navigation-user-btn dropdown-toggle" data-toggle="dropdown">
                        <div className="display-flex align-items-center space-between">
                          <div className="display-flex align-items-center">
                            <img src={currentUser.avatar} className="avatar-medium" />
                            <div className="navigation-user-info">
                              <div className="navigation-user-username truncate-inside">{currentUser.username}</div>
                              <div className="navigation-user-email truncate-inside">{currentUser.email}</div>
                            </div>
                          </div>

                          <HiChevronUpDown size={21}/>
                        </div>
                      </div>
                      
                      <ul class="dropdown-menu animated fadeInUp" role="menu">
                        <li>
                          <a onClick={() => setOpenEditAccount(true)}>
                            <i className="fal fa-user-cog"></i>Account settings
                          </a>
                          <Modal open={openEditAccount} onClose={() => setOpenEditAccount(false)} className="modal-body-white" classNames={{modal: 'width-500'}} center>
                            <Edit closeModal={() => {setOpenEditAccount(false);}}/>
                          </Modal>
                        </li>

                        <li>
                          <a onClick={() => setOpenTheme(true)}>
                            <i className="fal fa-lightbulb-on"></i>Edit Theme
                          </a>
                          <Modal open={openTheme} onClose={() => setOpenTheme(false)} className="modal-body-white" classNames={{modal: 'width-500'}} center>
                            <EditTheme organization={organizationAuthorizations.organization} refetchData={() => {}}/>
                          </Modal>
                        </li>
                        <li>
                          <a onClick={() => setOpenMobilePopup(true)}><i class="fas fa-mobile-alt"></i>Download mobile app</a>
                          <Modal open={openMobilePopup} onClose={() => setOpenMobilePopup(false)} className="modal-body-white" classNames={{modal: 'width-500'}} center>
                            <div className="display-flex align-items-center justify-content-between">
                              <div className="row onboarding-qr-code-wrapper">
                                <label className="text-center mb-25"><i class="fab fa-apple" style={{fontSize: "40px"}}></i></label>
                                <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fqueue-platform-for-agencies%2Fid1501942318" className="communication-download-image" />
                                <p className="opacity-6 text-center">iOS</p>
                              </div>


                              <div className="row onboarding-qr-code-wrapper">
                                <label className="text-center mb-25"><i class="fab fa-android" style={{fontSize: "40px"}}></i></label>
                                <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fqueue-platform-for-agencies%2Fid1501942318" className="communication-download-image" />
                                <p className="opacity-6 text-center">Android</p>
                              </div>
                            </div>
                          </Modal>
                        </li>
                        {isMacOs && 
                          <li>
                            <a href="https://desktop.usequeue.com" target="blank"><i class="fal fa-desktop"></i>Download desktop app</a>
                          </li>
                        }
                        <li class="divider"></li>
                        <li>
                          <a id="signOut" href={`/signout?electron=${electron}`} className="mixpanelTrack" data-mixpaneltrack="Navigation - Signout"><i className="fal fa-sign-out-alt"></i>Log out</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <Checklist /> */}
                </div>

                {(organizationAuthorizations.organization.organization_user && !organizationAuthorizations.organization_subscribed.subscribed && !organizationAuthorizations.organization_subscribed.tier === null) && 
                  <a type="button" class="btn btn-primary btn-small side-nav-upgrade-button" style={{background: "none"}} data-toggle="dropdown" onClick={fetchCheckoutUrl}>
                    ✨ Upgrade ✨
                  </a>
                }
              </div>
            </>
          }

          {isMobile && 
            <MobileNavbar />
          }

          {(!organizationAuthorizations.organization_subscribed.allow_access && !window.location.pathname.includes("people")) && 
            <div className="please-upgrade-wrapper">
              <div className="subscription-required-wrapper">
                {step === 1 && 
                  <Player style={{width: "300px", margin: "auto"}} mode="normal" autoplay loop src={lottieConfetti} />
                }
                {step === 2 &&
                  <div className="animated fadeIn slow-1">
                    <h1 className="margin-none">🥳</h1>
                    <h3 className="font-weight-600 mt-0">{t("Congrats on getting a client!")}</h3>
                    <div className="animated fadeIn delay-3 mt-25">
                      <p className="opacity-6">{t("Now that you have a client, it's time to have an active subscription to continue using Queue.")}</p>
                      <p className="font-12 opacity-6" style={{marginBottom: 30}}>{t("Don't worry, your client still has full access.")}</p>
                      <a disabled={disabled} className="btn btn-primary animated delay-4" onClick={()=> fetchCheckoutUrl()}><i class="fal fa-rocket mr-8"></i>Upgrade</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          {/* NEW LAYOUT */}
          <div className={(!organizationAuthorizations.organization_subscribed.allow_access && !window.location.pathname.includes("people")) ? "blur-background queue-platform-layout" : "queue-platform-layout"}>
            {/* toggle projects sidebar  */}
            {/* {!isMobile && 
              <>
                {(!showSidenav) ? <div className="display-center cp background-2 toggle-sidenavigation" style={{position: "absolute"}} onClick={() => setShowSidenav(!showSidenav)}><i data-tip="Click to show sidebar" class="fal fa-grip-lines-vertical project-wrapper-toggler"></i></div> : <div className="display-center cp animate toggle-sidenavigation toggle-position" onClick={() => setShowSidenav(!showSidenav)}><i data-tip="Click to hide sidebar" class="fal fa-grip-lines-vertical project-wrapper-toggler"></i></div>}
              </>
            } */}
            
            {(organizationAuthorizations.organization_subscribed.days_left != null) && 
              <TrialEnding organizationAuthorizations={organizationAuthorizations} upgrade={fetchCheckoutUrl}/>
            }

            {/* Fixed Breadcrumb */}
            <div className="queue-platform-breadcrumb">
              <a className="pr-15 border-right mr-15 color-1" onClick={() => setShowSidenav(!showSidenav)}>
                <i class={`fal fa-window-maximize`} style={{transform: "rotate(-90deg)"}}></i>
              </a>
              <Breadcrumbs />
            </div>

            <Switch>
              <Route path={`/o/:organization_id/dashboard`} render={() => <Dashboard projectAuthorizations={organizationAuthorizations}/> } />
              
              <Suspense fallback={<div></div>}>
                <Route exact path={`/o/:organization_id/projects`} render={() => <LazyHome/> } />
                <Route path="/o/:organization_id/billing" component={LazyServicesWrapper}/>
                <Route exact path="/o/:organization_id/workflow/forms" component={LazyTaskFormsIndex}/>
                <Route exact path="/o/:organization_id/workflow/task_templates" component={LazyTaskTemplates}/>
                <Route exact path="/o/:organization_id/workflow/taskboard-templates" component={LazyTaskBoards}/>
                <Route exact path="/o/:organization_id/workflow/client-onboarding" component={LazyClientOnboardingsNew}/>
                <Route path="/o/:organization_id/workflow/reviews" component={LazyReviews}/>
                <Route path={`/o/:organization_id/people`} render={() => <LazyPeople/> } />
                <Route path="/o/:organization_id/settings" component={LazySettings}/>
                <Route path="/o/:organization_id/chatrooms" component={LazyChatroomsWrapper}/>
                <Route exact path="/o/:organization_id/themes" component={LazyThemes}/>
                <Route path={`/o/:organization_id/projects/:project_id`} render={() => <LazyProjectWrapper fetchProjects={fetchProjects}/>} />
                <Route path={`/o/:organization_id/timesheets`} render={() => <LazyTimesheetsDashboard/>} />
                <Route path={`/o/:organization_id/reports`} render={() => <LazyReportsWrapper/>} />
              </Suspense>
            </Switch>
          </div>
        </div>
      </ProjectContext.Provider>
      <TaskNotifications 
        newTasks={newTasks} 
        setNewTasks={setNewTasks}
      />
    </React.Fragment>
  )
}

export default Projects;
